<template>
    <form class="space-y-4" @submit.prevent="createTree">
        <FormErrors :errors="vuelidate.$errors" />
        <SelectInput placeholder="Árbol" :items="treeFruits" v-model="vuelidate.tree.fruit_id.$model" :value="vuelidate.tree.fruit_id.$model" />
        <InputComponent type="text" placeholder="Nombre" :value="vuelidate.tree.name.$model" v-model="vuelidate.tree.name.$model" />
        <label class="block">
            <span class="block mb-2">Fecha de siembra</span>
            <input v-model="vuelidate.tree.bday.$model" type="date" class="w-full p-3 border rounded-xl border-light_green" />
        </label>
        <h3 class="font-bold text-enriqueto_green">Ubicación</h3>
        <MapInputPoint
            :center="[harvest.lon,harvest.lat]"
            :id="'mapaInputPoint'"
            :locations_area="area"
            :area="true"
            @selected-location="updateLocation($event)"
        />
        <SubmitButtonComponent value="Guardar" />
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import { computed } from 'vue'
import InputComponent from './InputComponent.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import SelectInput from './SelectInput.vue'
import useNotification from '../../Services/useNotification'
import MapInputPoint from '../Map/MapInputPoint.vue'

export default {
    components: { InputComponent, SubmitButtonComponent, FormErrors, SelectInput, MapInputPoint },
    props: ['tree', 'fruits', 'farm', 'harvest', 'area'],
    validations() {
        return {
            tree: {
                name: { required },
                lon: { required },
                lat: { required },
                bday: { required },
                fruit_id: { required },
            },
        }
    },
    setup(props, { emit }) {
        const vuelidate = useVuelidate()
        const api = useApi()
        const tree = ref(props.tree)
        const notificate = useNotification()
        const treeFruits = computed(() => props.fruits.filter(fruit => fruit.categories?.some(category =>
            ['frutas', 'hongos'].includes(category.name.trim().toLocaleLowerCase('es'))
        )))

        const createTree = async () => {
            const valid = await vuelidate.value.$validate()
            if (!valid) {
                notificate.error('Revisa el formulario')
                return
            }

            api.addTree(props.harvest.id, tree.value).then(response => {
                tree.value = response.data.tree
                notificate.success('Guardado con éxito')
                Inertia.reload()
                emit('added')
            }).catch(() => {
                notificate.error('No fue posible guardar el árbol')
            })
        }

        const updateLocation = location => {
            tree.value.lon = location[0]
            tree.value.lat = location[1]
        }

        return { tree, treeFruits, createTree, vuelidate, updateLocation }
    }
}
</script>
